export enum TrackingSource {
  JobDetails = 'job-details',
  TransparentJobDetails = 'transparent-job-details',
}
